import { StudioArt, StudioAssetPhoto } from '../types'
import { DEFAULT_ART_DEFAULTS } from '../constants'
import { generateLocalId } from '../babylon/sceneMath'
import { getGallerySlotCount } from '@/features/gallery-wizard/galleryMeshCatalog'
import { DEFAULT_CLASSIC_FRAME_ID, DEFAULT_CLASSIC_MAT_W } from '../classicCatalog'

/**
 * Places photos into a Classic room's fixed slots for a brand-new gallery
 * seed — same per-print defaults `convertLegacyClassicGallery` uses for a
 * legacy topic, but for photos that never went through the old pattern
 * editor. Slot alignment is positional (slot index -> photo index), the
 * same assumption `useStudioLegacyRoom` makes. Photos beyond the chosen
 * template's slot count are dropped — Classic's toolbar has no "hang
 * another print"; resizing means picking a bigger family/variant in
 * `RoomInspector` instead.
 */
export function layoutClassicArts(photos: StudioAssetPhoto[], templateId: number): StudioArt[] {
  const slotCount = getGallerySlotCount(templateId)
  return photos.slice(0, slotCount).map((photo, i) => ({
    id: generateLocalId('art'),
    egoId: photo.egoId,
    img: photo.url || photo.thumbUrl || '',
    name: `Print ${i + 1}`,
    y: 2.3,
    u: 0,
    side: 0,
    ...DEFAULT_ART_DEFAULTS,
    classicFrameId: DEFAULT_CLASSIC_FRAME_ID,
    classicMatW: DEFAULT_CLASSIC_MAT_W,
  }))
}
